export default {
  tc: {
    empty: '請輸入{{name}}以繼續',
    invalid: '{{name}}無效',
    confirmEmail: '請確認電郵地址以繼續',
    emailNotEquals: '電郵不相符',
    notSelected: '請選擇{{name}}以繼續',
    serverResponse: {
      tooOftenVerification: '每分鐘只能接收一次驗證碼',
      codeNotCorrect: '驗證碼不正確或失效，請重試',
      accountNotExists: '此電話號碼並未有登記',
      alreadyRegistered: '此電話號碼已登記',
      unknownError: '出現錯誤',
    }
  },
  sc: {
    empty: '请输入{{name}}以继续',
    invalid: '{{name}} 无效',
    confirmEmail: '请确认电邮地址以继续',
    emailNotEquals: '电邮不相符',
    notSelected: '请选择{{name}}以继续',
    serverResponse: {
      tooOftenVerification: '每分钟只能接收一次验证码',
      codeNotCorrect: '验证码不正确或失效，请重试',
      accountNotExists: '此电话号码并未有登记',
      alreadyRegistered: '此电话号码已登记',
      unknownError: '出现错误',
    }
  },
  en: {
    empty: 'Enter {{name}} to continue',
    invalid: '{{name}} is invalid',
    confirmEmail: 'Please confirm your email address',
    emailNotEquals: 'Two emails are different',
    notSelected: 'Select {{name}} to continue',
    serverResponse: {
      tooOftenVerification: 'You can only recieve verification code once per minute',
      codeNotCorrect: 'Verification code not correct',
      accountNotExists: 'This mobile number has not been registered',
      alreadyRegistered: 'This mobile no. is already registered',
      unknownError: 'Unknown error',
    }
  }
};
